export default "__VITE_ASSET__BBZpzi0D__"